import { useParams } from "react-router-dom";

import { usePageQuery } from "@/features/admin/features/pages-management";
import { useDashboardNavigationElementFromPageQuery } from "@/features/admin/hooks";

export const usePageData = () => {
  const { dashboard, page: pageId } = useParams();

  const pageQuery = usePageQuery(String(pageId));
  const navigationElement = useDashboardNavigationElementFromPageQuery(
    String(dashboard),
    String(pageId),
  );

  return {
    parentNavigationElement: navigationElement.data,
    page: pageQuery.data,
  };
};
